import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import WeatherSVGIcon from '../weather-svg-icon/';

export const TempScaleButton = ({ children, onClick, ...props }) => {
	let action = () => onClick && onClick(children[0]);
	return (<div class={props.class} onClick={action}>{children}</div>);
};

const isCelsius = (unit) => unit && unit.toUpperCase() === 'C';

export const CurrentTemperature = ({ temp }) => (<div class={style.temp}>{temp}&deg;</div>);

const Current = ({ isCompact, today, unit = 'F', changeUnit }) => {
	if (!today) {
		return;
	}

	/**
	 * Render the Current Weather component
	 * @param  {boolean} isCompact	Display compact view?
	 * @param  {Object} today      Current weather information
	 * @param  {string} unit        Temperature units in use 'C' or 'F'
	 * @param  {Function} changeUnit} Callback for updating the unit type used
	 * @return {string}             The rendered component
	 */
	let currentTemp = (isCelsius(unit)) ? today.currentTempCels : today.currentTemp;


	return (
		<div class={cx(style.current, isCompact && style.compact)}>
			<div class={style.temperature}>
				{isCompact &&
					<div class={style.icon}>
						<WeatherSVGIcon name={today.weatherIconCode} class={style.conditionIcon} />
					</div>
				}
				<CurrentTemperature temp={currentTemp} />
				{!isCompact &&
				<div class={style.degreePicker}>
					<TempScaleButton
						class={cx(style.fahrenheit, !isCelsius(unit) && style.active)}
						onClick={changeUnit}
					>
						F
					</TempScaleButton>
					<TempScaleButton
						class={cx(style.celsius, isCelsius(unit) && style.active)}
						onClick={changeUnit}
					>
						C
					</TempScaleButton>
				</div>
				}
			</div>

			{!isCompact &&
				<div>
					<div class={style.icon}>
						<WeatherSVGIcon name={today.weatherIconCode} class={cx(style.conditionIcon)} />
					</div>
					<div class={style.description}>
						<p>{today.conditionDescription}</p>
					</div>
				</div>
			}
		</div>
	);
};
export default Current;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/components/current/index.js